import React, { useEffect } from "react";
import {
  normalizeHtml,
  validateBillingForms,
  validateGuestForms,
  validateSignupForm,
} from "../../../../utils/formValidation";
import {
  apiBody,
  formatApiBody,
  formatPlaceOrderApiBody,
  signupApiBody,
} from "./ApiBody";

const OrderSummary = ({
  data,
  bookingData,
  addonCart,
  handleNext,
  nextStep,
  formData,
  setErrors,
  loggedInDetails,
}) => {
  const [loading, setLoading] = React.useState(false);
  const packagePrice = parseFloat(
    (data?.product?.list_price * parseInt(bookingData?.adults)).toFixed(2),
  );
  const childPackage = data?.productVariant?.filter(
    (item) => item?.variant?.toLowerCase() === "child",
  );
  const adultPackage = data?.productVariant?.filter(
    (item) => item?.variant?.toLowerCase() === "adult",
  );
  const childPackagePrice =
    bookingData?.child > 0 &&
    Array.isArray(data?.productVariant) &&
    childPackage.length > 0
      ? parseFloat(
          (childPackage?.[0]?.lst_price * parseInt(bookingData.child)).toFixed(
            2,
          ),
        )
      : null;

  const addonTotal = parseFloat(
    addonCart &&
      Object.values(addonCart)
        .reduce((acc, item) => {
          return acc + item.list_price * item.quantity;
        }, 0)
        .toFixed(2),
  );

  const addonCGST = parseFloat(
    addonCart &&
      Object.values(addonCart)
        .reduce((acc, item) => {
          return acc + item.cgst * item.quantity;
        }, 0)
        .toFixed(2),
  );

  const addonSGST = parseFloat(
    addonCart &&
      Object.values(addonCart)
        .reduce((acc, item) => {
          return acc + item.sgst * item.quantity;
        }, 0)
        .toFixed(2),
  );

  const sgst = parseFloat(
    Array.isArray(data?.productVariant) &&
      (adultPackage?.[0]?.sgst).toFixed(2) * parseInt(bookingData?.adults),
  );

  const cgst = parseFloat(
    Array.isArray(data?.productVariant) &&
      (adultPackage?.[0]?.cgst).toFixed(2) * parseInt(bookingData?.adults),
  );

  const childCGST = parseFloat(
    Array.isArray(data?.productVariant) &&
      (childPackage?.[0]?.cgst).toFixed(2) * parseInt(bookingData?.child),
  );

  const childSGST = parseFloat(
    Array.isArray(data?.productVariant) &&
      (childPackage?.[0]?.sgst).toFixed(2) * parseInt(bookingData?.child),
  );

  const handleNextMove = () => {
    //handle product order summary
    if (nextStep === "Login") {
      const order = {
        product: data,
        addon: addonCart,
        totalAmount: Math.round(
          packagePrice +
            childPackagePrice +
            addonTotal +
            cgst +
            sgst +
            addonCGST +
            addonSGST +
            childCGST +
            childSGST,
        ),
      };

      if (typeof window !== "undefined" && window.sessionStorage) {
        sessionStorage.setItem("userOrderSummary", JSON.stringify(order));
      }

      handleNext(3);
    }

    // Handle Signup and Login
    if (nextStep === "GuestDetails-Login") {
      const isLoggedIn =
        loggedInDetails &&
        typeof loggedInDetails === "object" &&
        !!loggedInDetails.customerId;

      if (!isLoggedIn) {
        alert("Please login to continue");
        return;
      }

      if (typeof window !== "undefined" && window.sessionStorage) {
        sessionStorage.setItem("userLogin", JSON.stringify(loggedInDetails));
        sessionStorage.removeItem("userSignup");
      }
      handleNext(4);
      return;
    } else if (nextStep === "GuestDetails-Signup") {
      if (typeof window !== "undefined" && window.sessionStorage) {
        sessionStorage.removeItem("userLogin");
      }
      callSignupApi();
      return true;
    }

    //handle guest and billing details
    if (nextStep === "Checkout") {
      const isGuestValid = validateGuestForms(
        formData.guest,
        setErrors.guestErrors,
      );

      const isChildValid = validateGuestForms(
        formData.child,
        setErrors.childErrors,
      );

      const isInfantValid = validateGuestForms(
        formData.infant,
        setErrors.infantErrors,
      );

      const isBillingValid = validateBillingForms(
        formData.billingFormData,
        setErrors.billingErrors,
      );

      // ❌ If ANY validation fails → stop execution
      if (!isGuestValid || !isChildValid || !isInfantValid || !isBillingValid) {
        return false;
      }

      // ✅ ALL validations passed → call API
      const apiBody = formatPlaceOrderApiBody(formData.user, formData);
      callPlaceOrderApi(apiBody);
    }

    //handle process to payment
    if (nextStep === "Payment") {
      let userLogin;
      if (typeof window !== "undefined" && window.sessionStorage) {
        userLogin = JSON.parse(sessionStorage.getItem("userLogin"));
      }
      let userSignup;
      if (typeof window !== "undefined" && window.sessionStorage) {
        userSignup = JSON.parse(sessionStorage.getItem("userSignup"));
      }
      const apiBody = {
        bookingId: userLogin?.bookingId
          ? userLogin?.bookingId
          : userSignup?.bookingId,
        customerId: userLogin?.customerId
          ? userLogin?.customerId
          : userSignup?.customerId,
        paymentGateway: "RAZORPAY",
      };

      callPaymentApi(apiBody);
    }
  };

  const callSignupApi = async () => {
    const apiUrl = `/dial-api/encalm/customer `;
    let bookingData;
    if (typeof window !== "undefined" && window.sessionStorage) {
      bookingData = JSON.parse(sessionStorage.getItem("userBookingDetail"));
    }
    let userOrder;
    if (typeof window !== "undefined" && window.sessionStorage) {
      userOrder = JSON.parse(sessionStorage.getItem("userOrderSummary"));
    }
    const totalAmount =
      packagePrice + childPackagePrice + addonTotal + cgst + sgst;
    if (formData?.password !== formData?.confirmPassword) {
      alert("Password and Confirm Password do not match");
      return false;
    }
    if (validateSignupForm(formData, setErrors)) {
      let apiBody = signupApiBody(formData, bookingData, userOrder);
      // console.log("signup",apiBody)
      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(apiBody),
        });
        const result = await response.json();
        if (
          typeof window !== "undefined" &&
          window.sessionStorage &&
          result.status === "ok" &&
          result.message === "success"
        ) {
          const signupData = {
            ...formData,
            bookingId: result.bookingId,
            customerId: result.customerId,
          };
          sessionStorage.setItem("userSignup", JSON.stringify(signupData));
          handleNext(4);
        } else if (
          result.status === "ok" &&
          result.message === "user already exists"
        ) {
          alert("user already exists! please login");
          return false;
        } else {
          alert("Error in signup process, please try again later");
          return false;
        }
      } catch (error) {
        console.error("Error calling API:", error);
        throw error;
      }
    }
  };

  const callPlaceOrderApi = async (apiBody) => {
    const apiUrl = `/dial-api/encalm/placeorder`;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(apiBody),
      });
      const result = await response.json();
      if (result.status === "ok" && result.message === "success") {
        if (result?.bookingOrderId) {
          if (typeof window !== "undefined" && window.sessionStorage) {
            sessionStorage.setItem(
              "userGuestBillingData",
              JSON.stringify(formData),
            );

            sessionStorage.setItem("PlaceOrderResult", JSON.stringify(result));
          }
          handleNext(5);
        }
      } else {
        alert("Error while placing order, please try again later");
      }
    } catch (error) {
      console.error("Error calling API:", error);
      throw error;
    }
  };

  const callPaymentApi = async (apiBody) => {
    setLoading(true);
    const apiUrl = `/dial-api/encalm/payment`;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(apiBody),
      });
      const result = await response.json();
      if (result?.status === "ok" && result?.message === "success") {
        const html = result?.data?.payment;

        let cleaned = normalizeHtml(html);

        const container = document.createElement("div");
        container.innerHTML = cleaned.trim();

        const form = container.querySelector("form");
        if (form) {
          let action = form.getAttribute("action");
          if (action) {
            action = action.replace(/['"]+/g, ""); // strip quotes
            const match = action.match(/https?:\/\/[^\s]+/i);

            if (match) {
              const url = match[0]; // the real external URL
              // const url = 'https://www.joinandsell.com/newdelhiairport/encalm/default-2023.aspx'

              if (!url.includes("localhost") && !url.includes("127.0.0.1")) {
                form.setAttribute("action", url);
              } else {
                console.warn("Ignored localhost action:", url);
              }
            } else {
              console.warn("No valid external URL found in action:", action);
            }
          }

          form.setAttribute("method", "POST");
          form.setAttribute("target", "_self");

          document.body.appendChild(form);

          form.submit();
          setLoading(false);
        } else {
          console.error("No form found in payment HTML");
        }
      } else {
        setLoading(false);
        alert("Error in payment process, please try again later");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error calling API:", error);
      throw error;
    }
  };

  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        setLoading(false);
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);

  useEffect(() => {
    // when Checkout mounts, ensure loader is off
    setLoading(false);
  }, []);

  return (
    <div className="bg-[#E6EAEF] rounded-[0.5vw] font-redhatRegular">
      <h2 className="text-[3.5vw] md:text-[2.5vw] xl:text-[1.3vw] font-redhatBold mb-[1vw] px-[3vw] xl:px-[1.5vw] py-[3vw] xl:py-[2vw]">
        Order Summary
      </h2>
      <div className="space-y-[2vw] xl:space-y-[0.6vw] text-[3.5vw] md:text-[2vw] xl:text-[1vw]">
        <div className="flex justify-between font-redhatMedium px-[3vw] xl:px-[1.5vw] py-[0.2vw]">
          <span>{`${data?.product?.name}(${bookingData?.adults} Adult)`}</span>
          <span>{`₹ ${packagePrice}`}</span>
        </div>
        {bookingData?.child && data?.productVariant.length > 0 ? (
          <div className="flex justify-between font-redhatMedium px-[3vw] xl:px-[1.5vw] py-[0.2vw]">
            <span>{`${data?.productVariant[1]?.name}(${bookingData?.child} Child)`}</span>
            <span>{`₹ ${childPackagePrice}`}</span>
          </div>
        ) : null}
        {addonCart &&
          Object.entries(addonCart).map(([name, item], ind) => (
            <div
              key={ind}
              className="flex justify-between font-redhatMedium px-[3vw] xl:px-[1.5vw] py-[0.2vw]"
            >
              <span>{name}</span>
              <span>{`₹ ${item?.list_price * item?.quantity}`}</span>
            </div>
          ))}
        <div className="flex justify-between font-redhatMedium px-[3vw] xl:px-[1.5vw] py-[0.2vw]">
          <span>Net Amount</span>
          <span>{`₹ ${(packagePrice + childPackagePrice + addonTotal).toFixed(
            2,
          )}`}</span>
        </div>
        <div className="flex justify-between font-redhatMedium px-[3vw] xl:px-[1.5vw] py-[0.2vw]">
          <span>SGST (9%)</span>
          <span>{`₹ ${(sgst + addonSGST + childSGST).toFixed(2)}`}</span>
        </div>
        <div className="flex justify-between font-redhatMedium px-[3vw] xl:px-[1.5vw] py-[0.2vw]">
          <span>CGST (9%)</span>
          <span>{`₹ ${(cgst + addonCGST + childCGST).toFixed(2)}`}</span>
        </div>
        <div className="flex bg-white justify-between font-redhatBold px-[3vw] xl:px-[1.5vw] py-[2vw]">
          <span>Final Amount</span>
          <span>{`₹ ${Math.round(
            packagePrice +
              childPackagePrice +
              addonTotal +
              sgst +
              cgst +
              addonCGST +
              addonSGST +
              childCGST +
              childSGST,
          )}`}</span>
        </div>
      </div>
      <div className="flex justify-center  py-[3vw] xl:py-[1vw]">
        <button
          onClick={handleNextMove}
          className="mt-[2vw] w-[50%] bg-[#002C5F] text-white rounded-lg py-[0.8vw] font-redhatMedium hover:bg-[#004080] transition"
        >
          {loading ? "Please Wait..." : "Proceed"}
        </button>
      </div>
    </div>
  );
};

export default OrderSummary;
